export default __webpack_public_path__ + "static/media/settings_genaral_img.f8c28649.svg";